import React from "react";
import { 
    Box, 
    Popover,
    PopoverTrigger,
    PopoverContent, 
    Icon, 
    Flex, 
    Text,
    List, 
    Divider,
    useDisclosure
} from "@chakra-ui/react";
import { GroupSchema, GroupsDropdownProps } from "../groups/Group.types";
import { BsFillFileEarmarkPostFill, BsX } from "react-icons/bs";
import { SearchProperty } from "../property/SearchProperty";
import { GroupItem } from "../groups/GroupItem";
import CustomModal from "../../../components/ui/modals";

export function GroupsDropdown({ data, children, type, onGroupItemClick, onGroupSelectionClear }: GroupsDropdownProps) {
    const [list, setList] = React.useState<GroupSchema[]>(data || []);
    const [groupIndex, setGroupIndex] = React.useState<string>("");
    const initRef = React.useRef(null)
    const { isOpen, onClose, onOpen } = useDisclosure()
  
    function handleSearch(value: string) {
      if (!value) {
        setList(list);
        return;
      }
      const newList = list.filter(item => item?.name.toLowerCase().includes(value.toLowerCase()));
      
      if (newList.length) {
        setList(newList);
      } else {
        setList(list);
      }
    }
  
    function handleGroupDelete() {
      setList(list.filter((x: GroupSchema) => groupIndex !== x.id));
      setGroupIndex("");
    }

    function handleGroupClear() {
      onGroupSelectionClear();
      onClose();
    }
  
    return (
      <>
        <Popover placement="bottom-start" initialFocusRef={initRef} isOpen={isOpen} onOpen={onOpen} onClose={onClose}>
              <PopoverTrigger>{children}</PopoverTrigger>
              <PopoverContent paddingY="1rem" >
                  <Flex paddingX="1rem" alignItems="center" paddingBottom='10px' justifyContent={'space-between'}>
                      <Flex alignItems="center" paddingBottom='10px'>
                        <Icon size={'md'} as={BsFillFileEarmarkPostFill} />
                        <Text fontSize="14px" fontWeight={500} paddingLeft="0.5rem" textTransform='capitalize'>
                            Groups ({type})
                        </Text>
                      </Flex>
                      <Box onClick={handleGroupClear} className='pointer'>
                        <Icon size={'md'} as={BsX} />
                      </Box>
                  </Flex>
                  <Divider />
                  {list.length > 4 && (
                    <Box paddingX="1rem">
                      <SearchProperty onChange={handleSearch} />
                  </Box>
                  )}
                  <List className={`${list.length > 4 ? 'list-scroll' : ''}`}>
                    {!list.length ? (
                      <Text marginTop={'2'}  marginBottom={'4'} fontSize='sm' textAlign={'center'}>No {type} created yet.</Text>
                    ) : (
                      list.map((item, index) => (
                        <GroupItem
                          key={index}
                          group={item}
                          onDelete={() => {setGroupIndex(item.id)}}
                          onClick={onGroupItemClick}
                          onClose={onClose}
                        />
                      ))
                    )}
                  </List>
              </PopoverContent>
        </Popover>

         {/* delete group modal */}
         <CustomModal
            isOpen={!!groupIndex}
            onCloseFn={() => setGroupIndex("")}
            isFooter
            size={'sm'}
            headerTitle='Delete group'
            footerSecondaryBtnLabel='Cancel'
            footerPrimaryBtnLabel='Delete'
            modalType='delete'
            footerPrimaryBtnFn={handleGroupDelete}
        >
          <Box className="w--100" mb={'4'}>
              <Text color='gray.600' fontSize='md'>
                  Delete group?
              </Text>
          </Box>
        </CustomModal>
      </>
    );
  }